export class SearchClass {
  keyword1 = '';
  keyword2 = '';
  intkeyword1 = 0;
  intkeyword2 = 0;
}
